<template>
	<div class="nav">
		<div class="icon-arrow-down" v-if="!$store.state.isSecondPage && current!=8" :class="current == 0 || current == 2 || current == 6 ? 'light' : 'dark'"></div>
		<div class="icon-return-top" v-if="!$store.state.isSecondPage && current != 0 " @click="backToTop(0)" :class="current == 0 || current == 2 || current == 6 ? 'dark' : 'light'"></div>
		<div class="icon-nav-meun" v-if="!$store.state.isSecondPage" @click="showNav" :class="current == 0 || current == 2 || current == 6 ? 'dark' : 'light'"></div>
		
		<!--内容页固定顶部导航-->
		<div class="fixed-nav" v-if="$store.state.isSecondPage" :class="'navBg'+current" :style="{'backgroundColor': bgColor2 +'!important'}">
			<div class="icon-nav-meun" @click="showNav" :class="current == 0 ? 'dark' : 'light'"></div>
			<div class="icon-btn-close" @click="closeMask"></div>
		</div>
		<van-popup v-model="show" round position="left" closeable :close-icon="closeIcon">
			<van-cell class="home" title="首　　页"  @click= "toPage('/m_index/0/0')"/>
			<van-collapse v-model="activeNames" v-for="(item, index) in navItems" :key="index" accordion @change="collapseChange(item, index)">
				<van-collapse-item :title="item.navText" :is-link="false" :name="item.name">
					<template #right-icon >
						 <van-icon name="arrow-down" class="van-icon van-icon-arrow van-cell__right-icon"/>
					</template>
					<template #title>
						<div>{{item.navText}}</div>
					</template>
					<van-cell v-for="(subitem, index) in item.subItems" :key="index" :title="subitem.text" @click= "toPage(subitem.urlLink)" />
				</van-collapse-item>
			</van-collapse>
		</van-popup>
	</div>
</template>
<script>
	import {eventBus} from '@/main.js'
	export default {
		props: {
			current: {
				type: Number,
				required: true,
			},
		},
		data() {
			return {
				show: false,
				closeIcon: require("../../../static/m/common/close-icon.png"),
				activeNames: '',
				bgColor2:'',
				navItems: [{
					name:"1",
					navText:"产品中心",
					subItems:[{
						text: "人工生物心脏瓣膜",
						urlLink: "/m_index/1/0"
					},{
						text: "瓣膜成形环",
						urlLink: "/m_index/1/1"
					},{
						text: "心脏外科生物补片",
						urlLink: "/m_index/1/2"
					},{
						text: "经导管主动脉瓣膜系统",
						urlLink: "/m_index/1/3"
					}]
				},{
					name:"2",
					navText:"资讯中心",
					subItems:[{
						text: "公司新闻",
						urlLink: "/m_index/2/0"
					},{
						text: "科普知识",
						urlLink: "/m_index/2/1"
					},{
						text: "临床病例",
						urlLink: "/m_index/2/2"
					}]
				},{
					name:"3",
					navText:"金仕生物",
					subItems:[{
						text: "公司介绍",
						urlLink: "/m_index/3/0"
					},{
						text: "企业文化",
						urlLink: "/m_index/4/0"
					}]
				},{
					name:"4",
					navText:"关于我们",
					subItems:[{
						text: "团队介绍",
						urlLink: "/m_index/5/0"
					},{
						text: "招贤纳士",
						urlLink: "/m_index/6/0"
					},{
						text: "联系我们",
						urlLink: "/m_index/7/0"
					}]
				},]
			}
		},
		mounted() {
		},
		watch:{
			"$store.state.isSecondPage":{
				handler(newVal,oldVal){
					this.$store.state.isSecondPage = newVal;
					// console.log(newVal)
				}
			},
			"$store.state.bgColor":{
				handler(newVal,oldVal){
					// console.log(newVal)
					this.bgColor2 = newVal;
					// this.subActiveIndex = newVal;
				}
			}
		},
		methods: {
			backToTop(index) {
				this.$emit("backTop", 0);
			},
			showNav() {
				this.show = true
			},
			toPage(url){
				this.show = false;
				// if (!this.$store.state.isListening) {
				// 	return;
				// }
				//发送监听事件
				eventBus.$emit('closeSecondPage');
				
				setTimeout(()=>{
					this.$router.replace({
						path: url
					});
				},500)
				// this.$router.replace()
			},
			closeMask(){
				// this.$store.commit("setSecondPage", false);
				eventBus.$emit('closeSecondPage',this.current);
			},
			closeThirdPage(){
				eventBus.$emit('closeThirdPage');
			},
			collapseChange(item, index) {
				this.$nextTick(() => {
					// console.log('name', this.activeNames)
					if (this.activeNames !== '') {
						// this.saveOptionRecord(item.htmlId, 'reading', item.title)
					}
				})
			},
			parseClassName(){
				var className = "";
				className = this.$store.state.isSecondPage ? 'second':''
				return 'navBg'+this.current+'_'+className
			}
		}
	}
</script>
<style lang="less">
	@import '@/assets/css/index';
	/deep/.van-hairline--top-bottom{
		width: 90% !important;
	}
	.van-popup {
		width: 1029/@r;
		height: 100%;
		.van-icon-closeIcon {
			.scale(64,65);
		}
		display: flex;
		flex-direction: column;
		justify-content: center;
		// font-size: 52/@r;
		.home {
			font-size: 52/@r;
			width: 95%;
		}
		.van-cell__title {
			display: flex;
			justify-content: space-between;
			// flex-direction: row-reverse;
			align-items: center;
		}
		.van-cell::after {
		    border-bottom: 0px solid #ebedf0;
		}
		.van-collapse{
			width: 95%;
		}
		.van-collapse-item {
			.van-collapse-item__title {
				height: 200/@r;
				display: flex;
				justify-content: space-between;
				// flex-direction: row-reverse;
				align-items: center;
			}
			.van-collapse-item__content {
				padding: 0 0 40/@r 0;
			}
			div {
				font-size: 52/@r;
			}
			.van-icon {
				vertical-align: -1%;
			}
		}
	}
	.icon-arrow-down, .icon-return-top, .icon-nav-meun {
		position: fixed;
	}
	.icon-arrow-down {
		background-image: url('../../../static/m/common/arrow.png');
		background-size: 42/@r 50/@r;
		left: 50%;
		transform: translateX(-50%);
		bottom: 50/@r;
		.scale(42,25);
		position: fixed;
		.animation(downArrow, 1s);
		&.light {
			background-position-y: -25/@r;
		}
		&.dark {
			background-position-y: -50/@r;
		}
	}
	.icon-nav-meun {
		left: 50/@r;
		top: 50/@r;
		background-image: url('../../../static/m/common/icon-nav-meun2.png');
		background-size: 71/@r 118/@r;
		.scale(71,63);
		position: fixed;
		opacity: 0.8;
		&.light {
			background-position:0 7/@r;
		}
		&.dark {
			background-position:0 -56/@r;
		}
	}
	.icon-return-top {
		right: 50/@r;
		top: 50/@r;
		background-image: url('../../../static/m/common/icon-return-top.png');
		background-size: 130/@r 260/@r;
		.scale(68,58);
		position: fixed;
		opacity: 0.8;
		&.light {
			background-position:-34/@r -10/@r;
		}
		&.dark {
			background-position:-34/@r -138/@r;
		}
	}
	.icon-btn-close{
		position: fixed;
		right: 50/@r;
		top: 50/@r;
		background-image: url('../../../static/m/common/close-icon.png');
		background-size: 64/@r 65/@r;
		.scale(64,65);
		// opacity: 0.8;
	}
	.fixed-nav{
		width: 100%;
		height: 140/@r;
		position: fixed;
		top: 0;
		// background-color: #eeede9;
		// &.navBg1{
		// 	background-color: #e5e3e1;
		// }
	}
	.navBg2{
		background-color: #eeede9;
	}
	.navBg3,.navBg4{
		background-color: #fff;
	}
	.navBg5,.navBg6{
		background-color: #e5e3e1;
	}
	@keyframes downArrow {
		0%{
			transform:translateY(50%);
		}
		100%{
			transform:translateY(0);
		}
	}
</style>
